import { render, staticRenderFns } from "./CategoryMenuGroupOrders.vue?vue&type=template&id=12c9fb37"
import script from "./CategoryMenuGroupOrders.vue?vue&type=script&lang=js"
export * from "./CategoryMenuGroupOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports